// extracted by mini-css-extract-plugin
export default {"location":"style_location__lFfF5","rate-face":"style_rate-face__5MoMa"};